module.exports = __webpack_public_path__ + "static/media/step-segment.a045bd8b.png";